export const GEOSERVER_WORKSPACE = 'povos_floresta_dev';

export const SPECIAL_TERRITORY_GEOSERVER_LAYERS: {[key: string]: string} = {
  'Quilombo': 'geo_quilombo',
  'PAE': 'geo_settlement',
}

export const ALERT_GEOSERVER_LAYER = 'geoserver_all';
